/**
 * GET TIME
 * @param {number} ts date as timestamp in second (like python TS)
 * @return {string} Human readable time: '08H22'
 */

export default {
  methods: {
    getTime(ts) {
      const hours = new Date(ts * 1000).getHours();
      const minutes = new Date(ts * 1000).getMinutes();
      return `${hours < 10 ? `0${hours}` : hours}H${minutes < 10 ? `0${minutes}` : minutes}`;
    },
  },
};
